<template>
  <span class="text" :style="{ '--trans_color': color }">{{ !!_t ? t(_t, { ...options }) : '' }}</span>
</template>
<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  _t: String,
  options: {
    type: Object,
    default: () => ({})
  },
  color: {
    type: String,
    default: 'inherit'
  }
})
const { t } = useI18n();
</script>
<style lang="scss" scoped>
.trans_text {
}
</style>